module.exports = __webpack_public_path__ + "img/wsczzhjkyypt4.8ded985c.png";